// ReusableSlider.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MyExamSlider= ({
  items = [],
  settings = {},
  renderItem,
  className = "",
}) => {
  const defaultSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    arrows: true,

    
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 },
      },
    ],
    ...settings,
  };

  const CustomPrevArrow = (props) => (
    <button {...props} className="slick-prev custom-arrow" aria-label="Prev">
      <i className="fa-solid fa-angle-left"></i>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="slick-next custom-arrow" aria-label="Next">
      <i className="fa-solid fa-angle-right"></i>
    </button>
  );

  
  return (
    <div className={`reusable-slider ${className}`}>
      <Slider
        {...defaultSettings}
        prevArrow={<CustomPrevArrow />}
        nextArrow={<CustomNextArrow />}
      >
        {items.map((item, index) => (
          <div key={index}>{renderItem(item, index)}</div>
        ))}
      </Slider>
    </div>
  );
};

export default MyExamSlider;
